import * as cookies from './Cookies';
import * as authenticator from './Authenticator';

let authProcessingFlg = false;

/**
 * post
 * @param {*} url
 * @param {*} params
 */
function post(url, params) {
  // console.log('request url: ' + url);
  // if (!cookies.getItem('access_token')) {
  //   console.log('アクセストークンが付与されていません。');
  //   return;
  // }
  const req = new XMLHttpRequest();
  req.open('POST', API_SERVER_URL + url);
  req.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
  req.setRequestHeader('X-Kitac-AuthToken', cookies.getItem('access_token'));
  req.send(JSON.stringify(params));
}

/**
 * post(コールバックあり)
 * @param {*} url
 * @param {*} params
 */
function post2(url, callback) {
  // console.log('request url: ' + url);
  // if (!cookies.getItem('access_token')) {
  //   console.log('アクセストークンが付与されていません。');
  //   return;
  // }
  const req = new XMLHttpRequest();
  req.open('POST', API_SERVER_URL + url, true);
  req.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
  req.setRequestHeader('X-Kitac-AuthToken', cookies.getItem('access_token'));
  req.timeout = TIMEOUT;

  // 受信が失敗した時に呼び出される
  req.onerror = () => {
    postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
    callback(new Error(-1), null); // -1 (上記以外のエラーコード)
  };

  req.onload = () => {
    if (req.readyState === 4) {
      console.log('response url(code): ' + url + '(' + String(req.status) + ')');
      if (req.status === 200) {
        sessionStorage.setItem('reAuthenticationCnt', 0); // 正常終了時再認証カウントをクリアする
        if (req.responseText === '') {
          callback(null, req.responseText);

        } else {
          callback(null, JSON.parse(req.responseText));

        }

      } else if (req.status === 400) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(400), null); // Bad Request

      } else if (req.status === 401) {
        let reAuthCnt = Number(sessionStorage.getItem('reAuthenticationCnt'));
        let nowTransition = Boolean(sessionStorage.getItem('nowTransition'));

        if (isNaN(reAuthCnt)) reAuthCnt = 0;
        if (isNaN(nowTransition)) nowTransition = false;
        //        if (nowTransition) return null;

        if (reAuthCnt < MAX_RE_AUTHENTICATION_CNT) {
          reAuthCnt += 1;
          authProcessingFlg = true;
          sessionStorage.setItem('reAuthenticationCnt', reAuthCnt);
          sessionStorage.setItem('recoverLastSearch', true);
          sessionStorage.setItem('nowTransition', true);
          authenticator.authorize();
          return null;
        } else {
          if (authProcessingFlg == true){
            // 認証中にほかのAPIが401を受けた場合
            // エラー処理を実施しない
          } else {
            postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
            callback(new Error(401), null); // Unauthorized
          }
        }

      } else if (req.status === 403) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);

        var bodyJson = JSON.parse(req.responseText);
        if (bodyJson['message'] && bodyJson['message'] == 'User is not authorized to access this resource with an explicit deny') {
          // 2重ログインエラー
          location.replace(`/error/403.html`);
          javascript_die();

        } else if (bodyJson['message']['reason'] && bodyJson['message']['reason'] == '503 Service Unavailable') {
          // メンテナンス中
          callback(new Error(503), null);

        } else {
          callback(new Error(403), null); // Forbidden
        }
      } else if (req.status === 404) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(404), null); // Not Found

      } else if (req.status === 500) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(500), null); // Internal Server Error

      } else if (req.status === 503) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(503), null); // Service Unavailable

      } else { // -1 (上記以外のエラーコード)
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(-1), null);
      }
    }
  };

  req.ontimeout = () => {
    postRequestErrors(408, req.responseText, API_SERVER_URL + url);
    callback(new Error(408), null); // XMLHttpRequest timed out. Do something here.
  };

  req.onabort = () => {
    postRequestErrors(-1, req.responseText, API_SERVER_URL + url);
    callback(new Error(-1), null);
  };

  req.send(null);
}


/**
 * reqest
 * @param {*} url
 * @param {*} callback
 */
function request(url, callback) {
  // console.log('request url: ' + url);
  // if (!cookies.getItem('access_token')) {
  //   console.log('アクセストークンが付与されていません。');
  //   return;
  // }
  const req = new XMLHttpRequest();
  req.open('GET', API_SERVER_URL + url, true);
  req.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
  req.setRequestHeader('X-Kitac-AuthToken', cookies.getItem('access_token'));
  req.timeout = TIMEOUT;

  // 受信が失敗した時に呼び出される
  req.onerror = () => {
    postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
    callback(new Error(-1), null); // -1 (上記以外のエラーコード)
  };

  req.onload = () => {
    if (req.readyState === 4) {
      console.log('response url(code): ' + url + '(' + String(req.status) + ')');
      if (req.status === 200) {
        sessionStorage.setItem('reAuthenticationCnt', 0); // 正常終了時再認証カウントをクリアする
        if (req.responseText === '') {
          callback(null, req.responseText);

        } else {
          callback(null, JSON.parse(req.responseText));

        }

      } else if (req.status === 400) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(400), null); // Bad Request

      } else if (req.status === 401) {
        let reAuthCnt = Number(sessionStorage.getItem('reAuthenticationCnt'));
        let nowTransition = Boolean(sessionStorage.getItem('nowTransition'));

        if (isNaN(reAuthCnt)) reAuthCnt = 0;
        if (isNaN(nowTransition)) nowTransition = false;
        //        if (nowTransition) return null;

        if (reAuthCnt < MAX_RE_AUTHENTICATION_CNT) {
          reAuthCnt += 1;
          authProcessingFlg = true;
          sessionStorage.setItem('reAuthenticationCnt', reAuthCnt);
          sessionStorage.setItem('recoverLastSearch', true);
          sessionStorage.setItem('nowTransition', true);
          authenticator.authorize();
          return null;
        } else {
          if (authProcessingFlg == true){
            // 認証中にほかのAPIが401を受けた場合
            // エラー処理を実施しない
          } else {
            postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
            callback(new Error(401), null); // Unauthorized
          }
        }

      } else if (req.status === 403) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);

        var bodyJson = JSON.parse(req.responseText);
        if (bodyJson['message'] && bodyJson['message'] == 'User is not authorized to access this resource with an explicit deny') {
          // 2重ログインエラー
          location.replace(`/error/403.html`);
          javascript_die();

        } else if (bodyJson['message']['reason'] && bodyJson['message']['reason'] == '503 Service Unavailable') {
          // メンテナンス中
          callback(new Error(503), null);

        } else {
          callback(new Error(403), null); // Forbidden
        }
      } else if (req.status === 404) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(404), null); // Not Found

      } else if (req.status === 500) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(500), null); // Internal Server Error

      } else if (req.status === 503) {
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(503), null); // Service Unavailable

      } else { // -1 (上記以外のエラーコード)
        postRequestErrors(req.status, req.responseText, API_SERVER_URL + url);
        callback(new Error(-1), null);
      }
    }
  };

  req.ontimeout = () => {
    postRequestErrors(408, req.responseText, API_SERVER_URL + url);
    callback(new Error(408), null); // XMLHttpRequest timed out. Do something here.
  };

  req.onabort = () => {
    postRequestErrors(-1, req.responseText, API_SERVER_URL + url);
    callback(new Error(-1), null);
  };

  req.send(null);
}

/**
 * subscribe
 */
export function postRequestErrors(status, body, url) {
  var location = url;
  //   const apiPath = `/shubetsu/terms?${formatParams}`;
  const loginId = cookies.getItem('userId');

  const params =
  {
    message: "HTTPSTATUS：" + status + "、" + body,
    location: location,
    occurred_at: new Date(),
    user_id: loginId,
    user_agent: platform.description,
    os_info: platform.os,
    screen_size:
    {
      width: screen.width,
      height: screen.height
    },
    window_size:
    {
      width: window.innerWidth,
      height: window.innerHeight
    }
  };

  // 空の要素を削除
  for (let key in params) {
    if (!params[key]) {
      delete params[key];
    }
  }

  // REST API呼出処理
  postServiceErrors(params);

}


/* ---------------パチンコ用レートのリストを取得する。------------------------------*/
/**
* レートのリストを返します。
*/
export function getPachinkoRates(callback) {
  const apiPath = '/pachinko/rates';
  request(apiPath, callback);
}

/* ---------------    スロット用レートのリストを取得する。------------------------------*/
/**
* レートのリストを返します。
*/
export function getSlotRates(callback) {
  const apiPath = '/slot/rates';
  request(apiPath, callback);
}

/* ---------------    パチンコ用機種タイプのリストを取得する。------------------------------*/
/**
 * タイプのリストを返します。
 */
export function getPachinkoTypes(callback) {
  const apiPath = '/pachinko/types';
  request(apiPath, callback);
}

/* ---------------  スロット用機種タイプのリストを取得する。------------------------------*/
/**
 * タイプのリストを返します。
 */
export function getSlotTypes(callback) {
  const apiPath = '/slot/types';
  request(apiPath, callback);
}

/* ---------------  メーカーのリストを取得する。 メーカーは50音順となる。------------------*/
/**
 * メーカーのリストを返します。 メーカーは50音順で返されます。
 */
export function getBrands(callback) {
  const apiPath = '/brands';
  request(apiPath, callback);
}

/* ---------------  遊技タイプのリストを取得する。------------------*/
/**
 * 遊技タイプのリストを返します。
 */
export function getYugiTypeNumbers(callback) {
  const apiPath = '/pachinko/yugi_types';
  request(apiPath, callback);
}

/* ---------------  号機のリストを取得する。------------------*/
/**
 * 号機のリストを返します。
 */
export function getUnitNumbers(callback) {
  const apiPath = '/slot/unit_numbers';
  request(apiPath, callback);
}

/* ---------------  レート別集計の区分のリストを取得する。---------------------------*/
/**
 * 区分のリストを返します。
 */
export function getShubetsuPartitions(callback) {
  const apiPath = '/shubetsu/partitions';
  request(apiPath, callback);
}

/* ---------------  パチンコ機種別集計の区分のリストを取得する。------------------------------*/
/**
 * 区分のリストを返します。
 */
export function getPachinkoPartitions(callback) {
  const apiPath = '/pachinko/partitions';
  request(apiPath, callback);
}

/* ---------------  スロット機種別集計の区分のリストを取得する。------------------------------*/
/**
 * 区分のリストを返します。
 */
export function getSlotPartitions(callback) {
  const apiPath = '/slot/partitions';
  request(apiPath, callback);
}

/* ---------------  種別のリストを取得する。------------------------------*/
/**
 * 種別のリストを返します。
 */
export function getShubetsu(callback) {
  const apiPath = '/shubetsu';
  request(apiPath, callback);
}

/* ---------------  レート別集計データの期間リストを取得する。------------------------------*/
/**
 * レート別集計データの期間リストを取得します。
 * 期間を表すオブジェクトのリストを返します。
 * time_units query
 * dimension query
 * partition query
 */
export function getShubetsuTerms(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/shubetsu/terms?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------  レート別集計データを取得する。------------------------------*/
/**
 * レート別集計のデータを返します。
 * term query
 * dimension query
 * partition query
 * day_filter query
 */
export function getShubetsuSummary(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/shubetsu/summary?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------  レート別推移データを取得する。------------------------------*/
/**
 * レート別推移のデータを返します。
 * term query
 * partition query
 * day_filter query
 */
export function getShubetsuRateTransitive(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/shubetsu/rate_transitive?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- 指定された種別の情報を取得する。------------------------------*/
/**
 * 種別の情報を返します。
 * id path
 */
export function getShubetsuByID(params, callback) {
  const apiPath = `/shubetsu/${params.id}`;
  request(apiPath, callback);
}

/* ---------------  指定された種別のデータの期間リストを取得する。------------------------------*/
/**
 * 指定された種別のデータの期間リストを取得します。
 * id path
 * time_units query
 * dimension query
 */
export function getShubetsuByIDterms(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/shubetsu/${id}/terms?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------  指定された種別IDの詳細な集計データを取得する。------------------------------*/
/**
 * 指定された種別の詳細な集計データを返します。
 * id path
 * term query
 * dimension query
 * day_filter query
 */
export function getShubetsuByIDSummary(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/shubetsu/${id}/summary?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------  パチンコ機種のリストを取得する。------------------------------*/
/**
 * 機種のリストを導入開始日の降順で返します。
 * type query
 * brand query
 * q query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getPachinko(params, callback) {
  const formatParams = jQuery.param(params);
  let apiPath = '/pachinko';
  if (formatParams !== '') {
    apiPath = `/pachinko?${formatParams}`;
  }
  request(apiPath, callback);
}

/**
 * パチンコ機種別集計データの期間リストを取得します。
 * 期間を表すオブジェクトのリストを返します。
 * time_units query
 * partition query
 */
export function getPachinkoTerms(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pachinko/terms?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- パチンコ機種別集計データを取得する。------------------------------*/
/**
 * パチンコ機種別集計のデータを返します。
 * term query
 * partition query
 * day_filter query
 * rate query
 * type query
 * brand query
 * q query
 * model query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getPachinkoSummary(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pachinko/summary?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------パチンコ機種別の期間推移データを取得する。------------------------------*/
/**
 * パチンコ機種の期間推移データを返します。
 * termパラメーターで指定した期間から過去13期間のデータを表示します。
 * 配列には、新しいデータから順に格納されます。
 * 機種別期間推移のデータを返します。
 * term query
 * partition query
 * day_filter query
 * rate query
 * type query
 * brand query
 * q query
 * model query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getPachinkoTrend(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pachinko/trend?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- パチンコ機種別の導入日別機種分析データを取得する。 ------------------------------*/
/**
* パチンコ機種別の導入日別機種分析データを取得します。
* 導入開始日がnohinkaishiパラメーターで指定した期間に存在する機種を表示します。
* 導入日別機種分析のデータを返します。
* nohinkaishi query
* type query
* band query
* q query
* model query
* limit query
* offset query
*/
export function getPachinkoProgress(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pachinko/progress?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- パチンコ選択ID機種情報取得 ------------------------------*/
/**
* 指定されたIDの機種の情報を返します。
* id path
*/
export function getPachinkoByID(params, callback) {
  const apiPath = `/pachinko/${params.id}`;
  request(apiPath, callback);
}

/* --------------- 選択パチンコ機種詳細集計データ期間リスト取得 ------------------------------*/
/**
 * 指定されたパチンコ機種の詳細な集計データの期間リストを取得します。
 * 期間を表すオブジェクトのリストを返します。
 * id path
 * rate query
 * time_units query
 * dimension query
 */
export function getPachinkoByIDTerms(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/pachinko/${id}/terms?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- 選択パチンコ機種詳細集計データ取得 ------------------------------*/
/**
 * 特定のパチンコ機種の詳細な集計データを返します。
 * レスポンスには、dimensionパラメーターで指定した評価軸の情報が含まれます。
 * パラメーターで指定していない評価軸の情報は含まれません。
 * id path
 * term query
 * rate query
 * dimension query
 * day_filter query
 */
export function getPachinkoByIDSummary(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/pachinko/${id}/summary?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット機種リスト取得 ------------------------------*/
/**
 * 機種のリストを導入開始日の降順で返します。
 * type query
 * brand query
 * q query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getSlot(params, callback) {
  const formatParams = jQuery.param(params);
  let apiPath = '/slot';
  if (formatParams !== '') {
    apiPath = `/slot?${formatParams}`;
  }
  request(apiPath, callback);
}

/* --------------- スロット機種別集計データ期間リスト取得 ------------------------------*/
/**
 * スロット機種別集計データの期間リストを取得します。
 * 期間を表すオブジェクトのリストを返します。
 * time_units query
 * partition query
 */
export function getSlotTerms(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/terms?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット機種別集計データ取得 ------------------------------*/
/**
 * スロット機種別集計のデータを返します。
 * term query
 * partition query
 * day_filter query
 * rate query
 * type query
 * brand query
 * q query
 * model query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getSlotSummary(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/summary?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット機種期間推移データ取得 ------------------------------*/
/**
 * スロット機種の期間推移データを返します。
 * termパラメーターで指定した期間から過去13期間のデータを表示します。
 * 配列には、新しいデータから順に格納されます。
 * 機種別期間推移のデータを返します。
 * term query
 * partition query
 * day_filter query
 * rate query
 * type query
 * brand query
 * q query
 * model query
 * nohinkaishi query
 * limit query
 * offset query
 *
 */
export function getSlotTrend(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/trend?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット機種別導入日別機種分析データ取得 ------------------------------*/
/**
 * スロット機種別の導入日別機種分析データを取得します。
 * 導入開始日がnohinkaishiパラメーターで指定した期間に存在する機種を表示します。
 * 導入日別機種分析のデータを返します。
 * nohinkaishi query
 * type query
 * brand query
 * q query
 * model query
 * limit query
 * offset query
 */
export function getSlotProgress(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/progress?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット選択ID機種情報取得 ------------------------------*/
/**
 * 指定されたIDの機種の情報を返します。
 * id path
 */
export function getSlotByID(params, callback) {
  const apiPath = `/slot/${params.id}`;
  request(apiPath, callback);
}

/* --------------- 選択スロット機種詳細集計データ期間リスト取得 ------------------------------*/
/**
 * 指定されたスロット機種の詳細な集計データの期間リストを取得します。
 * 期間を表すオブジェクトのリストを返します。
 * id path
 * rate query
 * time_units query
 * dimension query
 */
export function getSlotByIDTerms(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/slot/${id}/terms?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- 選択スロット機種詳細集計データ取得 ------------------------------*/
/**
 * 特定のスロット機種の詳細な集計データを返します。
 * レスポンスには、dimensionパラメーターで指定した評価軸の情報が含まれます。
 * パラメーターで指定していない評価軸の情報は含まれません。
 * id path
 * rate query
 * term query
 * dimension query
 * day_filter query
 */
export function getSlotByIDSummary(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/slot/${id}/summary?${formatParams}`;
  request(apiPath, callback);
}

/* --------------- スロット機種の段階設定別集計データを取得する。 ------------------------------*/
/**
 * 段階設定別データを返します。
 * settei query
 * type query
 * brand query
 * q query
 * model query
 * nohinkaishi query
 * limit query
 * offset query
 */
export function getSlotSetteiData(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/settei_data?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------  4円パチンコの最新機種情報を取得する。------------------------------*/
/**
 * 最新機種情報を返します。
 * データは納品開始日の降順の機種で、設置台数の多い機種から順に表示します。
 */
export function getPachinkoNewmodels(callback) {
  const apiPath = '/pachinko/newmodels';
  request(apiPath, callback);
}

/* ---------------  20円スロットの最新機種情報を取得する。------------------------------*/
/**
 * 最新機種情報を返します。
 * データは納品開始日の降順の機種で、設置台数の多い機種から順に表示します。
 */
export function getSlotNewModels(callback) {
  const apiPath = '/slot/newmodels';
  request(apiPath, callback);
}

/**
 * フロントエンド側のコードで発生したエラーを記録します。
 * デバッグ用途で使用します。
 * 記録したいエラー内容はJSON形式で、リクエストのBODY部に指定します。
 */
export function postServiceErrors(params) {
  const url = '/service_errors';
  post(url, params);
}

/* ---------------ログインAPIを実行する。------------------------------*/
/**
* ログインAPIを実行します。
*/
export function getLogin(callback) {
  const apiPath = '/login';
  request(apiPath, callback);
}

/* --------------- ダッシュボードで表示可能なデータ日付を返却する。------------------------------*/
/**
 * 集計済みの日付を、新しい7日間分を返却します。
 * ※日付は連続する保証はありません。
 * ※ソート：期間(日) 降順
 */
export function getDailyTerms(callback) {
  const apiPath = '/daily/terms';
  request(apiPath, callback);
}
/**
 * ピックアップ機種デイリーチャート（パチンコ）で使用します。
 * 10機種分のデータを返却します。
 * 並び順:納品開始日(降順)>アウト(降順)>機種コード(降順)
 */
export function getPickupPachinko(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pickup/pachinko?${formatParams}`;
  request(apiPath, callback);
}
/**
 * ピックアップ機種デイリーチャート（スロット）で使用します。
 * 10機種分のデータを返却します。
 * 並び順:納品開始日(降順)>アウト(降順)>機種コード(降順)
 */
export function getPickupSlot(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pickup/slot?${formatParams}`;
  request(apiPath, callback);
}
/**
 * デイリーアウトランキング（パチンコ）で使用します。
 * 15機種分のデータを返却します。
 * 並び順:アウト(降順)>平均設置台数(降順)>機種コード(降順)
 */
export function getDailyOutRankPachinko(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/daily_out_rank/pachinko?${formatParams}`;
  request(apiPath, callback);
}
/**
 * デイリーアウトランキング（スロット）で使用します。
 * 15機種分のデータを返却します。
 * 並び順:アウト(降順)>平均設置台数(降順)>機種コード(降順)
 */
export function getDailyOutRankSlot(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/daily_out_rank/slot?${formatParams}`;
  request(apiPath, callback);
}
/**
 * デイリーレート別推移グラフで使用します。
 * 指標(アウト、台売上、台粗利)ごとに、PS、4円、1円、20円、5円の推移データを返却します。
 * 日付の新しい順で返却します。
 */
export function getDailyRateTransitive(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/daily_rate/transitive?${formatParams}`;
  request(apiPath, callback);
}
/**
 * デイリーレート別集計で使用します。
 * PS各レートの集計データを返却します。
 * パチンコ、４円パチンコ、１円パチンコ、スロット、２０円スロット、５円スロット、平均の順に返却します。
 */
export function getDailyRateAggregate(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/daily_rate/aggregate?${formatParams}`;
  request(apiPath, callback);
}
/**
 * P-SENSORの自動ログインAPI用のアクセストークンを取得します。
 */
export function getPsensorToken(params, callback) {
  const apiPath = '/psensor/token';
  post2(apiPath, callback);
}

/* --------------- シン機種ページデータ取得 ------------------------------*/
/**
 * 総合評価API
 * シン機種ページの総合評価情報を取得します
 * id path
 * kubun path
 */
export function getModelsAssessment(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams, true);
  const apiPath = `/models/${id}/assessment?${formatParams}`;
  request(apiPath, callback);
}

/**
 * スタート分布(設定分布)グラフAPI
 * シン機種ページのスタート分布(設定分布)グラフ情報を取得します
 * id path
 * partition query
 */
export function getModelsDistribution(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams);
  const apiPath = `/models/${id}/distribution?${formatParams}`;
  request(apiPath, callback);
}

/**
 * あわせてチェックしたい機種API
 * シン機種ページのあわせてチェックしたい機種情報を取得します
 * id path
 * kubun path
 */
export function getModelsRecommend(params, callback) {
  const tmpParams = params;
  const id = tmpParams.id;
  delete tmpParams['id'];
  const formatParams = jQuery.param(tmpParams, true);
  const apiPath = `/models/${id}/recommend?${formatParams}`;
  request(apiPath, callback);
}
/* ---------------------------------------------------------------------*/

/* ---------------パチンコ用レート別比較のリストを取得する。------------------------------*/
/**
* レートのリストを返します。
*/
export function getPachinkoRateComparison(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/pachinko/rate_comparison?${formatParams}`;
  request(apiPath, callback);
}

/* ---------------    スロット用レート別比較のリストを取得する。------------------------------*/
/**
* レートのリストを返します。
*/
export function getSlotRateComparison(params, callback) {
  const formatParams = jQuery.param(params);
  const apiPath = `/slot/rate_comparison?${formatParams}`;
  request(apiPath, callback);
}
